<template>
  <div>

    <transition name="slide-fade" appear enter-active-class="animated flipInY" leave-active-class="animated fadeOutDown">
      <v-card width="300px">

        <v-layout align-center class="border-b--thin">
          <router-link to="/auth/sign-in" style="text-decoration: none;">
            <v-btn 
            icon>
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </router-link>
          <h3>Password reset</h3>
        </v-layout>

        <div class="pa-3">
          <transition name="slide-fade" appear enter-active-class="animated flash" leave-active-class="animated fadeOutDown">
            <p v-if="error.length > 0" class="error-text">
              {{ error }}
            </p>
          </transition>
          <form v-on:submit.prevent>
            <v-text-field
            v-model="email"
            :prepend-icon="'person'"
            :type="'email'"
            label="Email"
            color="deep-purple"
            spellcheck="false"
          ></v-text-field>
            <v-btn 
            class="white--text crx-gradient-purple font-weight-bold" 
            block
            rounded
            large
            @click="resetPassword"
            :loading="loading"
            :disabled="loading"
            >Reset password</v-btn>
          </form>

        </div>
      </v-card>
    </transition>

    <!-- dialog -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">You've got mail!</v-card-title>
        <v-card-text>An email has been sent to your registered email address with instructions.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" outlined @click="redirectToSignin">Sign in</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: localStorage.getItem('email'),
      password: '',
      dialog: false,
      loading: false,
      error: ''
    }
  },
  methods: {
    resetPassword () {
      this.loading = true
      this.$axios.post('users/password/request-reset',
        {email: this.email},
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            this.dialog = true
          }
        )
        .catch(
          (error) => {
            if (error.response.status === 404) {
              this.error = 'Email address does not exist on our system'
            } else {
              this.error = 'Invalid email address'
            }
            console.log(error)
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    redirectToSignin () {
      this.$router.push('/auth/sign-in')
    }
  }
}
</script>

<style scoped>
.card-header {
  border-bottom: 1px solid #EEE;
  padding: 10px;
}

h2 {
  text-align: center;
  color: white;
}

.error-text {
  color: #AD1457;
  text-align: center;
}
</style>
